<template>
  <main class="main">
    <div class="header-container">
      <HeaderPartial></HeaderPartial>
    </div>
    <div class="content" id="main-content">
      <router-view></router-view>
    </div>
    <div class="footer-container">
      <FooterPartial></FooterPartial>
    </div>
  </main>
</template>

<script>
import FooterPartial from '@/components/custom/FooterPartial';
import HeaderPartial from '@/components/custom/HeaderPartial';

export default {
  data () {
    return {}
  },
  components: { FooterPartial, HeaderPartial }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
@import 'nib'

.content
  box-sizing border-box
  relative top left
  overflow hidden
  flex-grow 1

.footer-container
  relative top left
  z-index 20
  background rgb(235, 239, 242)
  padding-top 20px
  box-shadow 0 -2px 3px -1px rgba(0, 0, 0, 0.16)

.main
  position relative
  overflow auto
  min-height 100vh
  background rgb(236, 239, 241)
  display flex
  flex-direction column

.header-container
  row()
  position relative
  display block
  z-index 21
  flex-basis auto

</style>
